<script setup lang="ts">
import { computed } from 'vue'
// types
import type { LinkBaseProps } from '../types/interfaces'

defineOptions({
  name: 'LinkBase',
})

const props = defineProps<LinkBaseProps>()

const refIsExternal = computed<boolean>(() => /^https?:\/\//.test(props.link.url))
</script>

<template>
  <a
    v-if="refIsExternal"
    class="ui-link-base"
    :href="link.url"
    :target="link.newTab ? '_blank' : undefined"
    :rel="link.newTab ? 'noopener noreferrer' : undefined"
  >
    <slot>{{ link.label }}</slot>
  </a>
  <NuxtLink
    v-else
    class="ui-link-base"
    :to="link.url"
    :target="link.newTab ? '_blank' : undefined"
    :prefetch="false"
  >
    <slot>{{ link.label }}</slot>
  </NuxtLink>
</template>

<style lang="scss" scoped src="../styles/_link-base.scss" />